export function uid(): string {
  return Math.random().toString(36).substring(2);
}
